// extracted by mini-css-extract-plugin
var _1 = "RDT8odSuwgY_RPOAo2ut";
export { _1 as "itemIcon" }
